import { render, staticRenderFns } from "./gatewayCheckStatus.vue?vue&type=template&id=22a21cf4&scoped=true&"
import script from "./gatewayCheckStatus.vue?vue&type=script&lang=js&"
export * from "./gatewayCheckStatus.vue?vue&type=script&lang=js&"
import style0 from "./gatewayCheckStatus.vue?vue&type=style&index=0&id=22a21cf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a21cf4",
  null
  
)

export default component.exports